import { GridInput } from '@it2go/data-grid';
import { filterFrag } from '../modules/content/service/types/filter.types';
import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import { WaitingListRatingCreateInput } from '@libs/types/src/services/input-type/waiting-list-rating-create.input';
import { WaitingListRatingUpdateInput } from '@libs/types/src/services/input-type/waiting-list-rating-update.input';
import {
    WaitingListRatingGridObject,
    WaitingListRatingObject,
} from '@libs/types/src/services/object-type/waiting-list-rating.object';

@Injectable({ providedIn: 'root' })
export class WaitingListRatingGqlService extends GqlServiceV2 {

    public getWaitingListRatings(input: GridInput, fragment: string) {
        return this.query<WaitingListRatingGridObject>(
            `
                query($input: GridInput!) {
                    waitingListRating {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createWaitingListRating(
        input: WaitingListRatingCreateInput,
        fragment: string,
    ) {
        return this.mutate<WaitingListRatingObject>(
            `
                mutation($input: WaitingListRatingCreateInput!) {
                    waitingListRating {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    updateWaitingListRating(
        input: WaitingListRatingUpdateInput,
        fragment: string,
    ) {
        return this.mutate<WaitingListRatingObject>(
            `
                mutation($input: WaitingListRatingUpdateInput!) {
                    waitingListRating {
                        update(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteWaitingListRating(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    waitingListRating {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
